import setValue from 'lodash/set'
import getValue from 'lodash/get'

export function getKeys (schema, keys = []) {
  schema.properties.forEach(property => {
    if (property.properties) getKeys(property, keys)
    if (property.isSection) return
    keys.push(property.path.join('/'))
  })
  return keys
}

export function applyDefaults (schema, result) {
  const keys = getKeys(schema)
  const schemaDefaults = getDefaults(schema)
  return keys.reduce((result, key) => {
    const defaultValue = getValue(schemaDefaults, key)
    setValue(result, key, getValue(result, key, defaultValue))
    return result
  }, result)
}

export function getDefaults (schema, result = {}) {
  schema.properties.forEach(property => {
    if (property.properties) getDefaults(property, result)
    if (property.isSection) return
    const key = property.path.join('/')
    setValue(result, key, property.default)
  })
  return result
}

export function setNewDefaults (schema, defaults = {}) {
  schema.properties.forEach(property => {
    if (property.properties) setNewDefaults(property, defaults)
    if (property.isSection) return
    const key = property.path.join('/')
    if (key in defaults) {
      property.default = defaults[key]
    }
  })
  return schema
}

export function wrap (schema) {
  schema = Object.create(schema)
  schema.properties = schema.properties.map(property => {
    if (property.properties) {
      return wrap(property)
    } else {
      return Object.create(property)
    }
  })
  return schema
}

export function getOutputType (inputType, schema) {
  let outputType = schema.types[inputType] || ''
  if (
    outputType === true || // has match
    !Object.keys(schema.types).length // accepts all if no types at all
  ) {
    outputType = inputType
  }
  return outputType
}



// WEBPACK FOOTER //
// ../webmango-core/lib/schema.js